import { FolderDataTable } from "@/components/SpecificFolder/FolderDataTable";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { getFolderData } from "@/redux/clients/clients.action";
import { useAppDispatch } from "@/redux/hooks";
import { Box, Typography } from "@mui/material";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const DataFolders = () => {
  const dispatch = useAppDispatch();
  const { folderId, nroDua } = useLocation().state;

  useEffect(() => {
    if (folderId) dispatch(getFolderData(folderId));
    if (nroDua) dispatch(getFolderData(nroDua));
  }, [dispatch, folderId, nroDua]);

  return (
    <Box className="flex flex-col p-4 h-full">
      <Card className="w-full h-full gap-0">
        <CardHeader className="flex flex-col gap-0">
          <CardTitle>
            <Typography fontFamily={"Inter"} fontSize={"18px"} fontWeight={500}>
              Datos de la carpeta {folderId}
            </Typography>
          </CardTitle>
          <CardDescription>
            <Typography fontFamily={"Inter"} fontSize={"14px"} fontWeight={400}>
              Gestiona los datos de la carpeta {folderId}.
            </Typography>
          </CardDescription>
          <Separator className="w-full mt-4 mb-2" />
        </CardHeader>
        <CardContent className="max-h-[100%] overflow-y-auto">
          <FolderDataTable />
        </CardContent>
      </Card>
    </Box>
  );
};
